import { Routes } from '@angular/router';
import { TermsAndConditionsComponent } from './terms-and-conditions.component';

export const ModuleRoutes: Routes = [
    {
        path: '',
        component: TermsAndConditionsComponent
    }
]
